import { z } from "zod";

const translationPath = "page.settings.crm.ticketDefaultDocCategories.errors.";

export const ticketDefaultDocCategorySchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, translationPath + "name"),
});

export type TTicketDefaultDocCategoryForm = z.infer<
  typeof ticketDefaultDocCategorySchema
>;
